// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"26a2495b","39":"929c087c","60":"bd56b7a5","110":"16e0f6c8","232":"e2286621","298":"184d8e73","389":"6e40b633","427":"d64ab432","579":"524e13ff","678":"0d01913e","694":"9e90bd92","897":"a56fb786"}[chunkId] + ".chunk.js";
};